(function (window) {

    function asyncLoad() {
      let urls = window.custom_scripts || [];
      let npc = [];
      for (let i = 0; i < urls.length; i++) {
        let np = new Promise((resolve, reject) => {
          let s = document.createElement('script');
          s.addEventListener('load', () => resolve(s))
          s.addEventListener('error', () => reject(new Error(`Failed to load script: "${urls[i]}"`)))
          s.type = 'text/javascript';
          s.async = true;
          s.defer = true;
          s.src = urls[i];
  
          /**
           * Loading scripts on either on head or below the body
           * 
           * If you want to load the scripts on the head use
           * let x = document.getElementsByTagName('script')[0];
           * x.parentNode.insertBefore(s, x);
           * 
           * 
           * Or if you want to load the scripts below the body
           * document.body.appendChild(s);
           */
  
          // Load the scripts below the body
          document.body.appendChild(s);
        });
        npc.push(np);
      }
      return Promise.all(npc);
    };
  
    document.addEventListener('scripts_ready', () => {
      if (Object.assign(window.custom_scripts).length) {
        window.requestIdleCallback(() => asyncLoad());
      }
    }, false);
  
  })(window);